import React, { useState, useContext, useEffect, useRef } from 'react';
import { Card, Form, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import GroupButtonsForm from '../helpers_components/GroupSubmitFormButtons';
import { register, initForm, termsRequest, ModalTermsAndConditions } from './register_logic';
import GoogleRecaptcha from '../helpers_components/GoogleRecaptcha';
import TextTooltip from '../helpers_components/text_tooltip/TextTooltip';
import Plain from '../layout/containers/Plain';
import LoaderContext from '../layout/shared/loader_context';
import {
  renderErrorsList,
  renderClassesToErrors,
} from '../confirm_registration/confirm_registration_logic';
import { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import moment from 'moment';
import TextAlertModal from '../modals/TextAlertModal';
import { backgroundImageStyles } from '../../inLineStyles/backgroundImageStyles/backgroundImageStyles';

moment.locale('es');
registerLocale('es', es);

const Register = (props) => {
  const [form, setForm] = useState(initForm);
  const Loader = useContext(LoaderContext);
  const [recaptcha, setRecaptcha] = useState('');
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const [handleTermsModal, setHandleTermsModal] = useState(false);
  const [termsText, setTermsText] = useState(false);
  const [termsTitle, setTermsTitle] = useState('');
  const [canShowModal, setCanShowModal] = useState(true);
  const [errors, setErrors] = useState({});
  const [textAlertRegistrationModal, setTextAlertRegistrationModal] = useState('');
  const [isRegistrationModalShowing, setIsRegistrationModalShowing] = useState(false);
  const captchaRef = useRef(null);

  useEffect(() => {
    (async function () {
      await termsRequest(setTermsTitle, setTermsText, setCanShowModal);
    })();
  }, []);

  const handleChangeForm = (event) => {
    setForm({
      ...form,
      [event.target.name]: event.target.value,
    });

    if (event.target.name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(event.target.value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: ['El campo email de tipo correo electrónico es inválido.'],
        }));
      } else {
        setErrors((prevErrors) => {
          const { email, ...rest } = prevErrors;
          return rest;
        });
      }
    } else if (event.target.name === 'password_confirmation') {
      if (event.target.value !== form.password) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password_confirmation: ['La confirmación de contraseña no coincide.'],
        }));
      } else {
        setErrors((prevErrors) => {
          const { password_confirmation, ...rest } = prevErrors;
          return rest;
        });
      }
    }
  };

  const onSubmitFormHandler = async (event) => {
    event.preventDefault();

    if (!recaptcha) {
      setPendingSubmit(true);
      if (captchaRef.current) {
        await captchaRef.current.execute();
      }
      return;
    }

    doRegister();
  };

  const doRegister = async () => {
    Loader.show(true);
    const registrationResponse = await register(form, recaptcha, setErrors, setForm);
    Loader.show(false);
    if (!registrationResponse) return;
    setTextAlertRegistrationModal(registrationResponse);
    setIsRegistrationModalShowing(true);
  };

  const onAccetRegistrationModal = () => {
    setIsRegistrationModalShowing(false);
    props.history.push('/');
  };

  const handleRecaptcha = (value) => {
    setRecaptcha(value);
  };

  useEffect(() => {
    if (pendingSubmit && recaptcha) {
      setPendingSubmit(false);
      doRegister();
    }
  }, [pendingSubmit, recaptcha]);

  const ModalToTermsAndConditions = ModalTermsAndConditions(
    handleTermsModal,
    setHandleTermsModal,
    termsText,
    termsTitle
  );

  return (
    <Plain {...props} noHeader={true} noFooter={true}>
      <Container
        fluid={true}
        className="min-height-100vh bg-size-cover"
        style={backgroundImageStyles}
      >
        <Container>
          <Row style={{ minHeight: '100vh' }}>
            <Col
              sm={12}
              md={{ span: 10, offset: 1 }}
              lg={{ span: 8, offset: 2 }}
              xl={{ span: 6, offset: 3 }}
              className="mY-30"
            >
              <Card className="mY-40@sm+">
                <Card.Header>
                  <Container>
                    <Row>
                      <Col
                        xs={12}
                        md={{ span: 10, offset: 1 }}
                        className="pT-20 pB-10 pT-30@sm+ pB-20@sm+"
                      >
                        <h3 className="mb-0">Crear Cuenta</h3>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs={12} md={{ span: 10, offset: 1 }} className="pT-30">
                      <p className="mB-30">
                        Para registrarte, por favor completa el siguiente formulario.
                      </p>

                      <Form onSubmit={onSubmitFormHandler} className="mB-20">
                        <Form.Group>
                          <TextTooltip
                            text={
                              'Selecciona el régimen fiscal bajo el cual realizarás tu registro de usuario. Obligatorio.'
                            }
                          >
                            <Form.Label className="font-weight-bold">* Regimen Fiscal</Form.Label>
                          </TextTooltip>

                          <Form.Control
                            name="regime"
                            onChange={handleChangeForm}
                            as="select"
                            required
                            value={form.regime}
                          >
                            <option value={''} disabled>
                              Regimen Fiscal...
                            </option>
                            <option value="1">Persona Fisica</option>
                            <option value="2">Persona Moral</option>
                          </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="formBasicCorreoElectronico">
                          <TextTooltip
                            text={
                              ' Ingresa el correo electrónico que será utilizado para la confirmación de tu cuenta. Obligatorio.'
                            }
                          >
                            <Form.Label className="font-weight-bold">* Correo</Form.Label>
                          </TextTooltip>
                          <Form.Control
                            type="email"
                            placeholder="Correo Electronico"
                            required
                            name="email"
                            onChange={handleChangeForm}
                            autoComplete="off"
                            className={renderClassesToErrors(errors, 'email')}
                            value={form.email}
                          />
                          {renderErrorsList(errors, 'email')}
                        </Form.Group>

                        <Form.Group controlId="formBasicCorreoContraseña">
                          <TextTooltip
                            text={'Crea una contraseña de mínimo 8 caracteres. Obligatorio.'}
                          >
                            <Form.Label className="font-weight-bold">* Contraseña</Form.Label>
                          </TextTooltip>
                          <Form.Control
                            type="password"
                            placeholder="Contraseña"
                            required
                            name="password"
                            value={form.password}
                            onChange={handleChangeForm}
                            className={renderClassesToErrors(errors, 'password')}
                          />
                          {renderErrorsList(errors, 'password')}
                          <div style={{ marginTop: '10px' }}>
                            <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
                              <li style={{ color: form.password.length >= 8 ? 'green' : 'red' }}>
                                {form.password.length >= 8 ? '✔' : '✖'} Mínimo 8 caracteres
                              </li>
                              <li style={{ color: /[A-Z]/.test(form.password) ? 'green' : 'red' }}>
                                {/[A-Z]/.test(form.password) ? '✔' : '✖'} Al menos una letra
                                mayúscula
                              </li>
                              <li style={{ color: /[a-z]/.test(form.password) ? 'green' : 'red' }}>
                                {/[a-z]/.test(form.password) ? '✔' : '✖'} Al menos una letra
                                minúscula
                              </li>
                              <li style={{ color: /[0-9]/.test(form.password) ? 'green' : 'red' }}>
                                {/[0-9]/.test(form.password) ? '✔' : '✖'} Al menos un número
                              </li>
                              <li
                                style={{
                                  color: /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(
                                    form.password
                                  )
                                    ? 'green'
                                    : 'red',
                                }}
                              >
                                {/[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(form.password)
                                  ? '✔'
                                  : '✖'}{' '}
                                Al menos un carácter especial
                              </li>
                            </ul>
                          </div>
                        </Form.Group>

                        <Form.Group controlId="formBasicCorreoConfirmarContraseña">
                          <TextTooltip text={'Confirmar contraseña. Obligatorio.'}>
                            <Form.Label className="font-weight-bold">
                              * Confirmar contraseña
                            </Form.Label>
                          </TextTooltip>
                          <Form.Control
                            type="password"
                            placeholder="Confirmar contraseña"
                            required
                            name="password_confirmation"
                            onChange={handleChangeForm}
                            className={renderClassesToErrors(errors, 'password_confirmation')}
                            value={form.password_confirmation}
                          />
                          {renderErrorsList(errors, 'password_confirmation')}
                        </Form.Group>

                        <div>
                          <Link to="/">Ya tengo cuenta</Link>
                        </div>
                        <div>
                          <p>
                            Al registrarme, aseguro haber leído y aceptado los
                            <span
                              onClick={
                                canShowModal
                                  ? () => {
                                      setHandleTermsModal(true);
                                    }
                                  : null
                              }
                              className="cursor-pointer text-primary px-1"
                            >
                              términos y condiciones
                            </span>
                            del uso del sistema.
                          </p>
                        </div>

                        <div className="overflow-auto w-100">
                          <GoogleRecaptcha ref={captchaRef} validate={handleRecaptcha} />
                        </div>
                        {!recaptcha ? renderErrorsList(errors, 'recaptcha') : null}
                        <GroupButtonsForm
                          primaryText="Registrarme"
                          secondaryText="Cancelar"
                          disabled={
                            Object.keys(errors).length > 0 ||
                            // !recaptcha ||
                            !form.email ||
                            !form.password ||
                            !form.password_confirmation ||
                            !form.regime
                          }
                        />
                      </Form>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </Container>
      <>{ModalToTermsAndConditions}</>
      <TextAlertModal
        headerText={'Alerta'}
        textAlert={textAlertRegistrationModal}
        isTextAlertModalShowing={isRegistrationModalShowing}
        hadleCloseTextAlertModal={onAccetRegistrationModal}
        hadleAcceptTextAlertModal={onAccetRegistrationModal}
      />
    </Plain>
  );
};

export default Register;
